import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';

const EditorIndexDirective = angularDirectiveToReact('editorIndex', {});

export function EditorIndexComponent() {
    useLoadEditorDependencies();
    const [key] = useAngularToReactRoute();
    return <EditorIndexDirective key={key} />;
}
